import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

export const UpgradeUserMessage = ({ emailAddress, companyName }) => (<div>
    <p>
        Are sure you would like to remove this user from <strong>{companyName}</strong>?
    </p>
    <p>
        {emailAddress}
    </p>
</div>);

UpgradeUserMessage.propTypes = {
    emailAddress: PropTypes.string,
    companyName: PropTypes.string,
};

export default connect(({ theme }) => ({
    companyName: theme.companyName,
}))(UpgradeUserMessage);



// WEBPACK FOOTER //
// ./src/client/Components/PromptModal/RemoveUserMessage.js